import React, { useMemo } from 'react';
import { ConsistencyHeatmap } from '../components/ConsistencyHeatmap';
import { MetricCard } from '../components/MetricCard';
import { PageHeader } from '../components/PageHeader';
import { Card } from '../components/ui/Card';
import { currentUser } from '../data/user';
import { useLocale } from '../contexts/LocaleContext';
import { useProgress } from '../contexts/ProgressContext';
import { average, buildHistory, perfectDays } from '../utils/history';
export function Heatmap() {
  const {
    t,
    dayUnit
  } = useLocale();
  const progress = useProgress();
  const history = useMemo(() => buildHistory(90, currentUser.streak), []);
  const withToday = useMemo(() => [...history, {
    date: new Date(),
    score: progress.todayScore
  }], [history, progress.todayScore]);
  const recorded = withToday.filter(day => day.score > 0).length;
  const consistency = Math.round(recorded / withToday.length * 100);
  return <div className="px-2 pb-2" data-id="element-2794" data-mp="3pw7e0w6xclw4">
      <PageHeader title={t('stats.heatmap.title')} subtitle={t('stats.heatmap.hint')} showBack data-id="element-2795" data-mp="3pv61ena9frca" />

      <Card className="p-2" data-id="element-2796" data-mp="qand2fap8ojp">
        <ConsistencyHeatmap records={withToday} data-id="element-2797" data-mp="q9ufa3tpx9dp" />
      </Card>

      <section className="mt-2 grid grid-cols-2 gap-2" data-id="element-2798" data-mp="v25fl7sdex6s">
        <MetricCard label={t('heatmap.consistency')} value={consistency} unit="%" hint={t('heatmap.consistencyHint')} accent data-id="element-2799" data-mp="v2nign9jg9no" />
        <MetricCard label={t('heatmap.recorded')} value={recorded} unit={dayUnit(recorded)} hint={t('heatmap.recordedHint')} data-id="element-2800" data-mp="3c0uf6wse64i" />
        <MetricCard label={t('stats.perfect')} value={perfectDays(withToday)} unit={dayUnit(perfectDays(withToday))} data-id="element-2801" data-mp="cb4fuhjfexm6" />
        <MetricCard label={t('stats.avg30')} value={average(withToday.slice(-30))} unit="/100" data-id="element-2802" data-mp="h84cy2yasq15" />
      </section>

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-2803" data-mp="1spnkg7iwvf5i">
        {t('heatmap.note')}
      </p>
    </div>;
}